<div class="dashboard-card card" *ngIf="loaded">
  <div class="card-body dashboard-card-content">
    <div class="title" translate>SALES_QUANTITY_PER_WEEK</div>

    <div class="d-flex justify-content-between">
      <div class="align-self-center">
        <span translate>THIS_WEEK</span>
      </div>
      <span class="current-statistic text-primary">{{ salesAmountThisWeek | number: '1.0-0' }}</span>
    </div>

    <div class="d-flex justify-content-between">
      <div class="align-self-center">
        <span translate>LAST_WEEK</span>
      </div>
      <span class="current-statistic text-primary">{{ salesAmountLastWeek | number: '1.0-0' }}</span>
    </div>

    <div class="progress-container mt-2">
      <ngb-progressbar [animated]="true" [value]="(salesAmountThisWeek / salesAmountLastWeek) * 100"> </ngb-progressbar>
      <div class="d-flex justify-content-between">
        <span class="sub-title">{{ ((salesAmountThisWeek / salesAmountLastWeek) * 100 || 0).toFixed() }}%</span>
        <span class="sub-title" translate>COMPARED_LAST_WEEK</span>
      </div>
    </div>
  </div>
</div>

<div class="dashboard-card card" *ngIf="!loaded">
  <div class="card-body dashboard-card-content">
    <div class="text-center dashboard-loading-spinner">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>
